import { css } from 'styled-components/macro'

export default function icon() {
  return css`
    font-family: 'icomoon' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
  `
}
